/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="paso-dos-container">
    <div class="form-section-header">
      <h3 class="header-icon">
        Paso 2: Consumo y Datos del Proyecto
      </h3>
      <p>Ingresa la información del proyecto y el método de recolección de datos de consumo eléctrico.</p>
    </div>

    <div class="form-grid">
      <div class="form-group-column cfe-details">
        <div class="form-grid cfe-info-grid">
          <div class="form-group span-3">
            <label class="label-resaltado">Cargar Proyecto Existente</label>
            <select @change="seleccionarProyecto($event.target.value)">
              <option value="">-- Crear Nuevo Proyecto --</option>
              <option v-for="proy in proyectosFiltrados" :key="proy.id_cotizacion" :value="proy.id_cotizacion">
                {{ proy.nombre_proyecto }} ({{ proy.codigo_proyecto || 'Sin código' }})
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="nombre-proyecto">Nombre del proyecto *</label>
            <input type="text" id="nombre-proyecto" :value="formData.nombreProyecto" maxlength="30"
              @input="updateField('nombreProyecto', $event.target.value)" placeholder="Nombre del proyecto">
          </div>
          <div class="form-group">
            <label>Estado *</label>
            <select :value="formData.estado_proyecto" @change="cambiarEstado($event.target.value)">
              <option value="">-- Selecciona Estado --</option>
              <option v-for="(estado, index) in listaEstados" :key="index" :value="estado.nombre">
                {{ estado.nombre }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Municipio (Localidad) *</label>
            <select :value="formData.localidadProyecto" @change="cambiarMunicipio($event.target.value)"
              :disabled="!formData.estado_proyecto">
              <option value="">-- Selecciona Municipio --</option>
              <option v-for="(muni, index) in municipiosDisponibles" :key="index" :value="muni.nombre">
                {{ muni.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group span-2">
            <label for="direccion">Dirección *</label>
            <input type="text" id="direccion" :value="formData.direccion" maxlength="100"
              @input="updateField('direccion', $event.target.value)" placeholder="Ingrese la dirección">
          </div>
          <div class="form-group">
            <label for="nueva-tarifa">Nueva tarifa CFE *</label>
            <select id="nueva-tarifa" :value="formData.tarifaCFE" @change="cambiarTarifa($event.target.value)">
              <option disabled value="">-- Selecciona una tarifa --</option>
              <option value="1">1</option>
              <option value="1A">1A</option>
              <option value="1B">1B</option>
              <option value="1C">1C</option>
              <option value="1D">1D</option>
              <option value="1E">1E</option>
              <option value="1F">1F</option>
              <option value="PDBT">PDBT</option>
              <option value="GDMTO">GDMTO</option>
              <option value="GDMTH">GDMTH</option>
            </select>
          </div>

          <div class="form-group">
            <label for="numero-servicio">Número de servicio *</label>
            <input type="number" id="numero-servicio" :value="formData.numeroServicio"
              @input="updateField('numeroServicio', $event.target.value)" placeholder="Número de servicio">
          </div>

          <div class="form-group" v-if="esComercial">
            <label for="nueva-division">Division *</label>
            <select id="nueva-division" @change="cambiarDivision($event.target.value)">
              <option disabled value="">-- Selecciona una division --</option>
              <option value="1">División Baja California Sur</option>
              <option value="2">División Baja California</option>
              <option value="3">División Bajío</option>
              <option value="4">División Centro Occidente</option>
              <option value="5">División Centro Oriente</option>
              <option value="6">División Centro Sur</option>
              <option value="7">División Golfo Centro</option>
              <option value="8">División Golfo Norte</option>
              <option value="9">División Jalisco</option>
              <option value="10">División Noroeste</option>
              <option value="11">División Norte</option>
              <option value="12">División Oriente</option>
              <option value="13">División Peninsular</option>
              <option value="14">División Sureste</option>
              <option value="15">División Valle de México Centro</option>
              <option value="16">División Valle de México Norte</option>
              <option value="17">División Valle de México Sur</option>

            </select>
          </div>

        </div>
      </div>
    </div>
    <hr class="form-divider">

    <div class="ajuste-precios-container">
      <div style="display: flex; justify-content: space-between;">
        <button type="button" class="btn-toggle-precios">
          Ajustar Costos del kWh
        </button>

        <button type="button" class="btn-video-trigger" @click="mostrarVideo = !mostrarVideo">
          {{ mostrarVideo ? '✕ Ocultar tutorial' : 'Ver tutorial para ajustar costos ' +
            (formData.tarifaCFE || '') }}
        </button>
      </div>


      <div v-if="mostrarAjustesPrecios" class="panel-precios">
        <div v-if="!esComercial" class="precios-domesticos-wrapper">
          <div class="precios-grid">
            <div class="grupo-precios">
              <h5>Precios Invierno</h5>
              <div class="input-precio">
                <label>Básico:</label>
                <input type="number" step="0.001" v-model.number="precios.INVIERNO.BASICO" @input="recalcularPrecios">
              </div>
              <div class="input-precio">
                <label>Intermedio:</label>
                <input type="number" step="0.001" v-model.number="precios.INVIERNO.INTERMEDIO"
                  @input="recalcularPrecios">
              </div>
              <div class="input-precio">
                <label>Excedente:</label>
                <input type="number" step="0.001" v-model.number="precios.INVIERNO.EXCEDENTE"
                  @input="recalcularPrecios">
              </div>
            </div>

            <div class="grupo-precios">
              <h5>Precios Verano</h5>
              <div class="input-precio">
                <label>Básico:</label>
                <input type="number" step="0.001" v-model.number="precios.VERANO.BASICO" @input="recalcularPrecios">
              </div>
              <div class="input-precio">
                <label>Intermedio:</label>
                <input type="number" step="0.001" v-model.number="precios.VERANO.INTERMEDIO" @input="recalcularPrecios">
              </div>
              <div v-show="mostarTarifaIntermedioAlta" class="input-precio highlight">
                <label>Int. Alto:</label>
                <input type="number" step="0.001" v-model.number="precios.VERANO.INTERMEDIO_ALTO"
                  @input="recalcularPrecios">
              </div>
              <div class="input-precio">
                <label>Excedente:</label>
                <input type="number" step="0.001" v-model.number="precios.VERANO.EXCEDENTE" @input="recalcularPrecios">
              </div>
            </div>
          </div>
        </div>

        <div v-if="esComercial" class="precios-comerciales-wrapper">
          <div class="precios-grid">
            <div class="grupo-precios" v-if="formData.tarifaCFE === 'PDBT'">
              <h5>Ajustes PDBT</h5>
              <div class="input-precio">
                <label>$/kWh:</label>
                <input type="number" step="0.01" v-model.number="precios.PDBT.PRECIO_KWH" @input="recalcularPrecios">
              </div>
              <div class="input-precio highlight">
                <label>Cargo Fijo ($):</label>
                <input type="number" step="0.01" v-model.number="precios.PDBT.CARGO_FIJO" @input="recalcularPrecios">
              </div>
            </div>

            <div class="grupo-precios" v-if="esGDMTH || esGDMTO">
              <h5>Config. General</h5>
              <div class="input-precio">
                <label>% Baja Tensión:</label>
                <input type="number" step="0.01" placeholder="0.02" v-model.number="precios.GDMTH.PORCENTAJE_BT"
                  @input="recalcularPrecios">
                <small style="display:block; font-size:10px; color:#666;">Ej. 0.02 para 2%</small>
              </div>
            </div>
            <div class="grupo-precios" v-if="esGDMTH">
              <h5>Ajustes GDMTH</h5>
              <div class="input-precio"><label>Base:</label><input type="number" step="0.0001"
                  v-model.number="precios.GDMTH.BASE" @input="recalcularPrecios"></div>
              <div class="input-precio"><label>Inter:</label><input type="number" step="0.0001"
                  v-model.number="precios.GDMTH.INTERMEDIO" @input="recalcularPrecios"></div>
              <div class="input-precio"><label>Punta:</label><input type="number" step="0.0001"
                  v-model.number="precios.GDMTH.PUNTA" @input="recalcularPrecios"></div>
              <hr style="margin: 5px 0; border:0; border-top:1px dashed #ccc;">
              <div class="input-precio highlight"><label>Dist ($/kW):</label><input type="number" step="0.01"
                  v-model.number="precios.GDMTH.DISTRIBUCION" @input="recalcularPrecios"></div>
              <div class="input-precio highlight"><label>Cap ($/kW):</label><input type="number" step="0.01"
                  v-model.number="precios.GDMTH.CAPACIDAD" @input="recalcularPrecios"></div>
              <div class="input-precio"><label>Cargo Fijo:</label><input type="number" step="0.01"
                  v-model.number="precios.GDMTH.CARGO_FIJO" @input="recalcularPrecios"></div>
            </div>

            <div class="grupo-precios" v-if="esGDMTO">
              <h5>Ajustes GDMTO</h5>
              <div class="input-precio"><label>$/kWh:</label><input type="number" step="0.0001"
                  v-model.number="precios.GDMTO.PRECIO_KWH" @input="recalcularPrecios"></div>
              <div class="input-precio highlight"><label>Costo fijo</label><input type="number" step="0.01"
                  v-model.number="precios.GDMTO.CARGO_FIJO" @input="recalcularPrecios"></div>
              <div class="input-precio highlight"><label>Distribución</label><input type="number" step="0.01"
                  v-model.number="precios.GDMTO.DISTRIBUCION" @input="recalcularPrecios"></div>
              <div class="input-precio highlight"><label>Capacidad</label><input type="number" step="0.01"
                  v-model.number="precios.GDMTO.CAPACIDAD" @input="recalcularPrecios"></div>
            </div>
          </div>
        </div>
        <small class="nota-precios">
          * Los cambios se aplican automáticamente.
        </small>

        <small v-show="mostrarSmallTextTarifas" class="nota-precios" style="margin-top: 0%;">
          ** Los costos de invierno y verano corresponden a {{fechaDeFueranDeVeranoSeleccionado}} y {{fechaDeVeranoSeleccionado}} respectivamente <br>
          *** Puede haber una demora entre los datos de la página oficial de CFE y Aniatek.
        </small>

        <hr class="form-divider-light" style="margin-top: 25px;">
        <div class="video-help-container">

          <div v-if="mostrarVideo" class="video-frame">
            <video :key="urlVideoTarifa" controls class="video-player">
              <source :src="urlVideoTarifa" type="video/quicktime">
              <source :src="urlVideoTarifa" type="video/mp4">
              Tu navegador no soporta el video.
            </video>

          </div>
        </div>
        <div class="video-footer">
          <a :href="linkReferenciaTarifa" target="_blank" class="btn-link-referencia">
            Ver Fuente de referencia oficial de CFE para tarifa {{ formData.tarifaCFE }}
          </a>
        </div>
      </div>
    </div>

    <div class="consumo-manual-section">
      <div class="form-section-header">
        <h3>Registro de Consumos</h3>
        <div class="captura-mode-selector">
          <label class="radio-label">
            <input type="radio" value="mensual" v-model="tipoCaptura">
            Mensual
          </label>
          <label class="radio-label">
            <input type="radio" value="bimestral" v-model="tipoCaptura">
            Bimestral
          </label>

          <template v-if="esGDMTH">
            <div class="divider-vertical"></div>
            <label class="radio-label checkbox-replicar">
              <input type="checkbox" v-model="usarUnSoloRecibo">
              <span>Cálculo Rápido (1 Recibo)</span>
            </label>
            <div v-if="usarUnSoloRecibo" class="inline-gdmth-inputs">
              <label class="label-mes-base">Mes del recibo:</label>
              <select v-model="mesBaseIndex" @change="alCambiarMesBase" class="select-mes-base">
                <option v-for="(consumo, index) in formData.consumos" :key="index" :value="index">
                  {{ mesesNombres[index] || consumo.termino }}
                </option>
              </select>
            </div>
          </template>

          <template v-else>
            <div class="divider-vertical"></div>

            <button type="button" class="btn-replicar" :class="{ 'btn-replicar-activo': usarUnSoloRecibo }"
              @click="toggleModoReplica">
              <i class="fa-solid" :class="usarUnSoloRecibo ? 'fa-check-circle' : 'fa-copy'"></i>

              <span>{{ usarUnSoloRecibo ? 'Replicando Mes 1' : 'Replicar Mes 1' }}</span>
            </button>
          </template>
        </div>
      </div>
    </div>

    <div class="consumption-table-wrapper">
      <table class="consumption-table">
        <thead>
          <tr>
            <th :rowspan="esGDMTH ? 2 : 1" class="sticky-col header-mes">Mes</th>
            <template v-if="esGDMTH">
              <th colspan="3" class="header-group-green">Consumo de Energía (kWh)</th>
              <th colspan="3" class="header-group-green-dark">Demanda Máxima (kW)</th>
              <th :rowspan="2" class="header-fp">Factor de<br>Potencia</th>
              <th :rowspan="2" class="header-fp">Demanda Máx<br>(Mensual)</th>
              <th :rowspan="2" class="header-fp">Consumo Total<br>(kWh)</th>
            </template>
            <template v-else>
              <th class="text-right">Consumo Total kWh</th>
              <template v-if="esGDMTO">
                <th class="text-right">Demanda (kW)</th>
                <th class="text-right">F.P. (%)</th>
              </template>
            </template>
            <th :rowspan="esGDMTH ? 2 : 1" class="text-right header-pago">Importe ($)</th>
          </tr>
          <tr v-if="esGDMTH" class="sub-header-row">
            <th class="sub-th">Base</th>
            <th class="sub-th">Intermedio</th>
            <th class="sub-th">Punta</th>
            <th class="sub-th">Base</th>
            <th class="sub-th">Intermedia</th>
            <th class="sub-th">Punta</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(consumo, index) in formData.consumos" :key="index">
            <tr v-if="tipoCaptura === 'mensual' || index % 2 === 0" :class="{
              'fila-seleccionada': usarUnSoloRecibo && index === mesBaseIndex,
              'fila-automatica': usarUnSoloRecibo && index !== mesBaseIndex
            }">
              <td class="cycle-label sticky-col">
                <span v-if="tipoCaptura === 'mensual'">{{ mesesNombres[index] || consumo.termino }}</span>

                <span v-else>
                  {{ obtenerNombreMes(consumo.termino) }} - {{ obtenerNombreMes(formData.consumos[index + 1]?.termino)
                  }}
                </span>
              </td>

              <template v-if="esGDMTH">
                <td class="bg-input">
                  <input type="number" class="input-excel" placeholder="0" :value="consumo.kwhBase" min="0"
                    max="9999999" :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                    @input="updateConsumo(index, 'kwhBase', $event.target.value)">
                </td>
                <td class="bg-input">
                  <input type="number" class="input-excel" placeholder="0" :value="consumo.kwhInter" min="0"
                    max="9999999" :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                    @input="updateConsumo(index, 'kwhInter', $event.target.value)">
                </td>
                <td class="bg-input">
                  <input type="number" class="input-excel" placeholder="0" :value="consumo.kwhPunta" min="0"
                    max="9999999" :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                    @input="updateConsumo(index, 'kwhPunta', $event.target.value)">
                </td>
                <td class="bg-input">
                  <input type="number" class="input-excel" placeholder="0" :value="consumo.kwBase" min="0" max="9999999"
                    :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                    @input="updateConsumo(index, 'kwBase', $event.target.value)">
                </td>
                <td class="bg-input">
                  <input type="number" class="input-excel" placeholder="0" :value="consumo.kwInter" min="0"
                    max="9999999" :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                    @input="updateConsumo(index, 'kwInter', $event.target.value)">
                </td>
                <td class="bg-input">
                  <input type="number" class="input-excel" placeholder="0" :value="consumo.kwPunta" min="0"
                    max="9999999" :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                    @input="updateConsumo(index, 'kwPunta', $event.target.value)">
                </td>
                <td class="bg-input">
                  <input type="number" class="input-excel" placeholder="%" :value="consumo.fp" min="0" max="100"
                    :disabled="false" @input="updateConsumo(index, 'fp', $event.target.value)">
                </td>
                <td>
                  <input v-if="usarUnSoloRecibo && index === mesBaseIndex" type="number" class="input-bloqueado"
                    :value="consumo.demanda" readonly placeholder="Auto">
                  <input v-else-if="usarUnSoloRecibo && index !== mesBaseIndex" type="number" class="input-excel-total"
                    :value="consumo.demanda" @input="updateDemandaManual(index, $event.target.value)"
                    placeholder="Max kW">
                  <input v-else type="number" class="input-bloqueado" :value="consumo.demanda" readonly>
                </td>
                <td>
                  <input v-if="usarUnSoloRecibo && index === mesBaseIndex" type="number" class="input-bloqueado"
                    :value="consumo.kwh" readonly placeholder="Suma...">
                  <input v-else-if="usarUnSoloRecibo && index !== mesBaseIndex" type="number" class="input-excel-total"
                    :value="consumo.kwh" @input="updateTotalManual(index, $event.target.value)" placeholder="Total kWh">
                  <input v-else type="number" class="input-bloqueado" :value="consumo.kwh" readonly>
                </td>
              </template>

              <template v-else>
                <td>
                  <input v-if="tipoCaptura === 'mensual'" type="number" placeholder="kWh" :value="consumo.kwh" min="0"
                    max="9999999" @input="updateConsumo(index, 'kwh', $event.target.value)">
                  <input v-else type="number" :value="getValorBimestral(index, 'kwh')" min="0" max="9999999"
                    @input="updateBimestral(index, 'kwh', $event.target.value)">
                </td>
                <template v-if="esGDMTO">
                  <td>
                    <input type="number" placeholder="kW" :value="consumo.demanda" min="0" max="9999999"
                      :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                      @input="updateConsumo(index, 'demanda', $event.target.value)">
                  </td>
                  <td>
                    <input type="number" placeholder="99%" :value="consumo.fp" min="0" max="100"
                      @input="updateConsumo(index, 'fp', $event.target.value)">
                  </td>
                </template>
              </template>

              <td>
                <input v-if="tipoCaptura === 'mensual'" type="number" readonly placeholder="$" :value="consumo.pago"
                  :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                  @input="updateConsumo(index, 'pago', $event.target.value)">
                <input v-else type="number" :value="getValorBimestral(index, 'pago')" readonly
                  :disabled="usarUnSoloRecibo && index != mesBaseIndex"
                  @input="updateBimestral(index, 'pago', $event.target.value)" class="input-bloqueado">
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="consumption-summary">
      <h4>Resumen Anual de Consumo</h4>
      <div class="summary-grid">
        <div class="summary-item">
          <label>Promedio kWh / Mes</label>
          <span class="dato-promedio">{{ averageKwh.toFixed(2) }} kWh</span>
        </div>
        <div class="summary-item">
          <label>Promedio Pago / Mes</label>
          <span class="dato-promedio">{{ formatMoney(averagePago) }}</span>
        </div>
        <div class="summary-item highlight-total">
          <label>Total Anual kWh</label>
          <span class="dato-total">{{ totalKwhAnual.toFixed(2) }} kWh</span>
        </div>
        <div class="summary-item highlight-total">
          <label>Total Anual Pagado</label>
          <span class="dato-total">{{ formatMoney(totalPagoAnual) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import estadosMunicipiosData from '@/data/estados_municipios.json';
import tarifasData from '@/data/tarifas.json';
import business_rates_Data from '@/data/business_rates.json';

const TARIFAS_RULES = {
  LIMITES: {
    '1': { invierno: [75, 65], verano: [75, 65, 0] },
    '1A': { invierno: [75, 75], verano: [100, 50, 100] },
    '1B': { invierno: [75, 100], verano: [125, 100, 0] },
    '1C': { invierno: [75, 100], verano: [150, 150, 150] },
    '1D': { invierno: [75, 125], verano: [175, 225, 200] },
    '1E': { invierno: [75, 125], verano: [300, 450, 150] },
    '1F': { invierno: [75, 125], verano: [300, 900, 1300] },
    'DAC': { invierno: [0, 0], verano: [0, 0, 0] }
  },
  MESES_VERANO: ['MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE']
};

export default {
  name: 'PasoDos',
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.$emit('update:formData', { ...this.formData, precios_cfe: this.precios });
  },
  props: {
    listas: { type: Object, default: () => ({}) },
    formData: { type: Object, required: true },
    averageKwh: { type: Number, required: true },
    averagePago: { type: Number, required: true },
    idCliente: { type: [Number, String], default: null },
  },
  emits: ['update:formData', 'set-id-cotizacion'],

  data() {
    return {
      tipoCaptura: 'mensual',
      ivaPorcentaje: 0.16,
      usarUnSoloRecibo: false,
      mostrarAjustesPrecios: true,
      mostarTarifaIntermedioAlta:false,
      mostrarSmallTextTarifas:false,
      mostrarVideo: false,
      mesBaseIndex: 0,
      mesesNombres: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ],
      listaEstados: estadosMunicipiosData.estados,
      precios: {
        INVIERNO: { BASICO: 0, INTERMEDIO: 0, EXCEDENTE: 0 },
        VERANO: { BASICO: 0, INTERMEDIO: 0, INTERMEDIO_ALTO: 0, EXCEDENTE: 0 },
        DAC: 0,
        CARGO_FIJO: 0.00,
        CARGO_FIJO_DAC: 0,
        PDBT: { PRECIO_KWH: 0, CARGO_FIJO: 0 },
        GDMTO: { CARGO_FIJO: 0, PRECIO_KWH: 0, DISTRIBUCION: 0, CAPACIDAD: 0, PORCENTAJE_BT: 0, FACTOR_CARGA_BASE: 0 },
        GDMTH: { CARGO_FIJO: 0, BASE: 0, INTERMEDIO: 0, PUNTA: 0, DISTRIBUCION: 0, CAPACIDAD: 0, PORCENTAJE_BT: 0, FACTOR_CARGA_BASE: 0 }
      }
    };
  },

  computed: {
    urlVideoTarifa() {
      const tarifa = this.formData.tarifaCFE;
      return tarifa ? `/videos/${tarifa}.mov` : '/videos/1.mov';
    },

    linkReferenciaTarifa() {
      const links = {
        '1': 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/TarifasCRECasa/Tarifas/Tarifa1.aspx',
        '1A': 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/TarifasCRECasa/Tarifas/Tarifa1A.aspx',
        '1B': 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/TarifasCRECasa/Tarifas/Tarifa1B.aspx',
        '1C': 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/TarifasCRECasa/Tarifas/Tarifa1C.aspx',
        '1D': 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/TarifasCRECasa/Tarifas/Tarifa1D.aspx',
        '1E': 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/TarifasCRECasa/Tarifas/Tarifa1E.aspx',
        '1F': 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/TarifasCRECasa/Tarifas/Tarifa1F.aspx',
        'PDBT': 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/tarifascrenegocio/tarifas/pequenademandabt.aspx',
        'GDMTO': 'https://app.cfe.mx/Aplicaciones/CCFE/Tarifas/TarifasCRENegocio/Tarifas/GranDemandaMTO.aspx',
        'GDMTH': 'https://app.cfe.mx/Aplicaciones/CCFE/Tarifas/TarifasCRENegocio/Tarifas/GranDemandaMTH.aspx'
      };
      return links[this.formData.tarifaCFE] || 'https://app.cfe.mx/aplicaciones/ccfe/tarifas/TarifasCRECasa/Tarifas/Tarifa1.aspx';
    },

    municipiosDisponibles() {
      if (!this.formData.estado_proyecto) return [];
      const estadoEncontrado = this.listaEstados.find(e => e.nombre === this.formData.estado_proyecto);
      return estadoEncontrado ? estadoEncontrado.municipios : [];
    },

    esGDMTH() { return this.formData.tarifaCFE === 'GDMTH'; },
    esGDMTO() { return this.formData.tarifaCFE === 'GDMTO'; },
    esComercial() { return this.esGDMTH || this.esGDMTO || this.formData.tarifaCFE === "PDBT" },

    proyectosFiltrados() {
      if (!this.listas.proyectosCliente || !this.idCliente) return [];
      return this.listas.proyectosCliente.filter(proy => (proy.id_cliente || proy.cliente || proy.cliente_id) == this.idCliente);
    },
    totalKwhAnual() {
      return this.formData.consumos ? this.formData.consumos.reduce((acc, c) => acc + (parseFloat(c.kwh) || 0), 0) : 0;
    },
    totalPagoAnual() {
      return this.formData.consumos ? this.formData.consumos.reduce((acc, c) => acc + (parseFloat(c.pago) || 0), 0) : 0;
    },
    fechaDeVeranoSeleccionado(){
      return tarifasData.fechas_seleccionadas.verano
    },
    fechaDeFueranDeVeranoSeleccionado(){
      return tarifasData.fechas_seleccionadas.fuera_de_verano
    }
  },

  methods: {
    updateField(field, value) {
      this.$emit('update:formData', { [field]: value });
    },
    toggleModoReplica() {
      this.usarUnSoloRecibo = !this.usarUnSoloRecibo;

      if (this.usarUnSoloRecibo) {
        this.toggleUnSoloRecibo(); 
      }
    },

    updateTotalManual(index, valorTotal) {
      const consumos = JSON.parse(JSON.stringify(this.formData.consumos));
      let total = parseFloat(valorTotal) || 0;
      const parte = parseFloat((total / 3).toFixed(2));
      const resto = parseFloat((total - (parte * 3)).toFixed(2));
      consumos[index].kwhBase = parte + resto;
      consumos[index].kwhInter = parte;
      consumos[index].kwhPunta = parte;
      consumos[index].kwh = total;
      const res = this.realizarCalculoMatematico(total, this.esMesVerano(consumos[index].termino), 'GDMTH', consumos[index]);
      consumos[index].pago = parseFloat(res.totalNeto.toFixed(2));
      this.$emit('update:formData', { ...this.formData, consumos });
    },

    updateDemandaManual(index, valorDemanda) {
      const consumos = JSON.parse(JSON.stringify(this.formData.consumos));
      let demanda = parseFloat(valorDemanda) || 0;
      consumos[index].kwBase = demanda;
      consumos[index].kwInter = demanda;
      consumos[index].kwPunta = demanda;
      consumos[index].demanda = demanda;
      const res = this.realizarCalculoMatematico(consumos[index].kwh, this.esMesVerano(consumos[index].termino), 'GDMTH', consumos[index]);
      consumos[index].pago = parseFloat(res.totalNeto.toFixed(2));
      this.$emit('update:formData', { ...this.formData, consumos });
    },

    alCambiarMesBase() {
      if (this.usarUnSoloRecibo) this.proyectarPromedio(this.mesBaseIndex);
    },

    proyectarPromedio(idxBase) {
      if (!this.formData.consumos) return;
      const consumos = JSON.parse(JSON.stringify(this.formData.consumos));
      const mesOrigen = consumos[parseInt(idxBase)];
      if (!mesOrigen) return;

      const totalKwh = (parseFloat(mesOrigen.kwhBase) || 0) + (parseFloat(mesOrigen.kwhInter) || 0) + (parseFloat(mesOrigen.kwhPunta) || 0);
      const maxDemanda = Math.max(parseFloat(mesOrigen.kwBase) || 0, parseFloat(mesOrigen.kwInter) || 0, parseFloat(mesOrigen.kwPunta) || 0, parseFloat(mesOrigen.demanda) || 0);
      const parteEnergia = parseFloat((totalKwh / 3).toFixed(2));
      const restoEnergia = parseFloat((totalKwh - (parteEnergia * 3)).toFixed(2));

      consumos.forEach((mes, i) => {
        if (i === parseInt(idxBase)) {
          mes.kwh = totalKwh;
          mes.demanda = maxDemanda;
        } else {
          mes.kwhBase = parteEnergia + restoEnergia;
          mes.kwhInter = parteEnergia;
          mes.kwhPunta = parteEnergia;
          mes.kwh = totalKwh;
          mes.kwBase = maxDemanda;
          mes.kwInter = maxDemanda;
          mes.kwPunta = maxDemanda;
          mes.demanda = maxDemanda;
          mes.fp = parseFloat(mesOrigen.fp) || 90;
          const res = this.realizarCalculoMatematico(totalKwh, this.esMesVerano(mes.termino), 'GDMTH', mes);
          mes.pago = parseFloat(res.totalNeto.toFixed(2));
        }
      });
      this.$emit('update:formData', { ...this.formData, consumos });
    },

    cambiarEstado(nuevoEstado) {
      this.$emit('update:formData', { estado_proyecto: nuevoEstado, localidadProyecto: '', latitud: '', longitud: '' });
    },

    cambiarMunicipio(nuevoMunicipio) {
      const estadoObj = this.listaEstados.find(e => e.nombre === this.formData.estado_proyecto);
      let lat = '', lon = '';
      if (estadoObj) {
        const muniObj = estadoObj.municipios.find(m => m.nombre === nuevoMunicipio);
        if (muniObj) { lat = parseFloat(muniObj.lat).toFixed(6); lon = parseFloat(muniObj.lon).toFixed(6); this.cambiarDivision(muniObj.div)}
      }
      this.$emit('update:formData', { localidadProyecto: nuevoMunicipio, latitud: lat, longitud: lon });
    },

    esMesVerano(nombreMes) {
      if (!nombreMes) return false;

      const valor = nombreMes.toString().toUpperCase().trim();

      if (!isNaN(valor)) {
        const numero = parseInt(valor);
        return numero >= 5 && numero <= 10;
      }

      const mesesVerano = ['MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT'];

      const esVerano = mesesVerano.some(mes => valor.includes(mes));

      if (valor.includes('ABR') || valor.includes('ENE') || valor.includes('FEB') || valor.includes('MAR') || valor.includes('NOV') || valor.includes('DIC')) {
        return false;
      }

      return esVerano;
    },
    getDiasDelMes(nombreMes) {
      if (!nombreMes) return 30;
      const m = nombreMes.toLowerCase();
      if (m.includes("febrero")) return 28;
      return ["abril", "junio", "septiembre", "noviembre"].some(x => m.includes(x)) ? 30 : 31;
    },

    formatMoney(val) {
      const n = parseFloat(val);
      return isNaN(n) ? '$0.00' : n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    },

    cambiarDivision(idDivision){
        if(Number.isFinite(parseFloat(idDivision))){
          //this.$emit('update:formData', {divisionCFE: idDivision});
          
          const tarifa = this.formData.tarifaCFE;

          if(tarifa === 'PDBT'){
              this.precios.PDBT.CARGO_FIJO=business_rates_Data[idDivision].PDBT.Fijo
              this.precios.PDBT.PRECIO_KWH=business_rates_Data[idDivision].PDBT.Variable
          }

          if(tarifa === 'GDMTH'){
              this.precios.GDMTH.BASE=business_rates_Data[idDivision].GDMTH.Variable.Base
              this.precios.GDMTH.INTERMEDIO=business_rates_Data[idDivision].GDMTH.Variable.Intermedia
              this.precios.GDMTH.PUNTA=business_rates_Data[idDivision].GDMTH.Variable.Punta

              this.precios.GDMTH.DISTRIBUCION = business_rates_Data[idDivision].GDMTH.Distribucion
              this.precios.GDMTH.CAPACIDAD =business_rates_Data[idDivision].GDMTH.Capacidad
              this.precios.GDMTH.CARGO_FIJO = business_rates_Data[idDivision].GDMTH.Fijo
              this.precios.GDMTH.PORCENTAJE_BT = 0.1
          }

          if(tarifa === 'GDMTO'){
              this.precios.GDMTO.DISTRIBUCION = business_rates_Data[idDivision].GDMTO.Distribucion
              this.precios.GDMTO.CAPACIDAD =business_rates_Data[idDivision].GDMTO.Capacidad
              this.precios.GDMTO.CARGO_FIJO = business_rates_Data[idDivision].GDMTO.Fijo
              this.precios.GDMTO.PRECIO_KWH = business_rates_Data[idDivision].GDMTO.Variable
              this.precios.GDMTO.PORCENTAJE_BT = 0.1
          }

          this.recalcularPrecios();

          const selectElement = document.getElementById('nueva-division');
          if(selectElement!= null) {selectElement.value = idDivision}
        }
    },

    cambiarTarifa(nuevaTarifa) {
  
      if(!["PDBT", "GDMTH", "GDMTO"].includes(nuevaTarifa)){
      const tarifaBuscada = "tarifa_" + nuevaTarifa;
      const preciosInverno = tarifasData.fuera_de_verano[tarifaBuscada];
      const preciosVerano = tarifasData.verano[tarifaBuscada];

      const sinIntermedioAlto = ["1", "1A", "1B"].includes(nuevaTarifa);

      this.precios.INVIERNO = {
        BASICO: preciosInverno.ConsBasico,
        INTERMEDIO: preciosInverno.ConsInt,
        EXCEDENTE: preciosInverno.ConsExcedente,
      };

      this.precios.VERANO = {
        BASICO: preciosVerano.ConsBasico,
        INTERMEDIO: sinIntermedioAlto ? preciosVerano.ConsInt : preciosVerano.ConsIntBajo,
        INTERMEDIO_ALTO: sinIntermedioAlto ? 0 : preciosVerano.ConsIntAlto,
        EXCEDENTE: preciosVerano.ConsExcedente,
      };

      this.mostarTarifaIntermedioAlta = !sinIntermedioAlto;
      this.mostrarSmallTextTarifas = true
    }else{
      this.mostrarSmallTextTarifas = false
    }

      this.recalcularPrecios()
      const consumos = this.formData.consumos.map(c => {
        const res = this.realizarCalculoMatematico(parseFloat(c.kwh) || 0, this.esMesVerano(c.termino), nuevaTarifa, c);
        return { ...c, pago: parseFloat(res.totalNeto.toFixed(2)) };
      });
      this.$emit('update:formData', { tarifaCFE: nuevaTarifa, consumos });
    },

    recalcularPrecios() {
      const tarifa = this.formData.tarifaCFE || '1F';

      const consumos = this.formData.consumos.map((c, index) => {
        let kwh = parseFloat(c.kwh) || 0;

        if (tarifa === 'GDMTH') {
          kwh = (parseFloat(c.kwhBase) || 0) + (parseFloat(c.kwhInter) || 0) + (parseFloat(c.kwhPunta) || 0);
        }

        const nombreMesSeguro = this.mesesNombres[index];
        const esVerano = this.esMesVerano(nombreMesSeguro);

        const res = this.realizarCalculoMatematico(kwh, esVerano, tarifa, c);

        return { ...c, pago: parseFloat(res.totalNeto.toFixed(2)) };
      });

      this.$emit('update:formData', { ...this.formData, consumos, precios_cfe: this.precios });
    },

    updateConsumo(index, field, value) {
      const consumos = JSON.parse(JSON.stringify(this.formData.consumos));

      consumos[index][field] = value;

      if (this.esGDMTH && ['kwhBase', 'kwhInter', 'kwhPunta'].includes(field)) {
        const b = parseFloat(consumos[index].kwhBase) || 0;
        const i = parseFloat(consumos[index].kwhInter) || 0;
        const p = parseFloat(consumos[index].kwhPunta) || 0;
        consumos[index].kwh = b + i + p;
      }

      if (this.esGDMTH && ['kwBase', 'kwInter', 'kwPunta'].includes(field)) {
        const db = parseFloat(consumos[index].kwBase) || 0;
        const di = parseFloat(consumos[index].kwInter) || 0;
        const dp = parseFloat(consumos[index].kwPunta) || 0;
        consumos[index].demanda = Math.max(db, di, dp);
      }

      const kwhParaCalculo = parseFloat(consumos[index].kwh) || 0;

      const nombreMesSeguro = this.mesesNombres[index];

      const res = this.realizarCalculoMatematico(
        kwhParaCalculo,
        this.esMesVerano(nombreMesSeguro), 
        this.formData.tarifaCFE,
        consumos[index]
      );

      consumos[index].pago = parseFloat(res.totalNeto.toFixed(2));

      this.$emit('update:formData', { ...this.formData, consumos });

      if (this.usarUnSoloRecibo && index === this.mesBaseIndex) {
        this.$nextTick(() => {
          if (this.esGDMTH) {
            this.proyectarPromedio(this.mesBaseIndex);
          } else {
            this.toggleUnSoloRecibo();
          }
        });
      }
    },

    getValorBimestral(index, field) {
      const m1 = parseFloat(this.formData.consumos[index][field]) || 0;
      const m2 = this.formData.consumos[index + 1] ? (parseFloat(this.formData.consumos[index + 1][field]) || 0) : 0;

      const suma = m1 + m2;
      return suma === 0 ? "" : (field === 'pago' ? suma.toFixed(2) : suma);
    },
    obtenerNombreMes(valor) {
      if (!valor) return '';
      const limpio = valor.toString().split(' ')[0];
      const numero = parseInt(limpio);

      const mesesCortos = [
        '', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];

      if (!isNaN(numero) && numero >= 1 && numero <= 12) {
        return mesesCortos[numero];
      }

      return limpio.substring(0, 3);
    },
    updateBimestral(index, field, value) {
      const consumos = JSON.parse(JSON.stringify(this.formData.consumos));
      const m = (parseFloat(value) || 0) / 2;
      if (field === 'kwh') {
        consumos[index].kwh = m; if (index + 1 < consumos.length) consumos[index + 1].kwh = m;
        [index, index + 1].forEach(i => {
          if (i < consumos.length) {
            const r = this.realizarCalculoMatematico(m, this.esMesVerano(consumos[i].termino));
            consumos[i].pago = parseFloat(r.totalNeto.toFixed(2));
          }
        });
      } else {
        consumos[index].pago = m; if (index + 1 < consumos.length) consumos[index + 1].pago = m;
      }
      this.$emit('update:formData', { consumos });
    },

    calcularAjusteFP(subtotal, fpValue) {
      const fp = parseFloat(fpValue) || 90;
      if (fp > 90) return -1 * (subtotal * (0.25 * (1 - (90 / fp))));
      if (fp < 90 && fp > 0) return Math.min(subtotal * (0.60 * ((90 / fp) - 1)), subtotal * 1.20);
      return 0;
    },

    realizarCalculoMatematico(consumoInput, esVeranoCalculo, tarifaOverride = null, filaConsumo = {}) {
      const kwhTotal = parseFloat(consumoInput) || 0;
      const tarifa = tarifaOverride || this.formData.tarifaCFE || '1F';

      if (tarifa === 'GDMTH') {
        const p = this.precios.GDMTH;
        const cE = ((parseFloat(filaConsumo.kwhBase) || 0) * p.BASE) + ((parseFloat(filaConsumo.kwhInter) || 0) * p.INTERMEDIO) + ((parseFloat(filaConsumo.kwhPunta) || 0) * p.PUNTA);
        const dF = Math.min(Math.max(parseFloat(filaConsumo.kwBase) || 0, parseFloat(filaConsumo.kwInter) || 0, parseFloat(filaConsumo.kwPunta) || 0), Math.ceil(kwhTotal / (p.FACTOR_CARGA_BASE * 24 * this.getDiasDelMes(filaConsumo.termino))));
        const sB = cE + (dF * p.DISTRIBUCION) + (dF * p.CAPACIDAD) + p.CARGO_FIJO;
        const sBT = sB + (sB * p.PORCENTAJE_BT);
        const net = (sBT + this.calcularAjusteFP(sBT, filaConsumo.fp)) * (1 + this.ivaPorcentaje);
        return { totalNeto: net };
      }

      if (tarifa === 'GDMTO') {
        const p = this.precios.GDMTO;
        const dF = Math.min(parseFloat(filaConsumo.demanda) || 0, Math.ceil(kwhTotal / (p.FACTOR_CARGA_BASE * 24 * this.getDiasDelMes(filaConsumo.termino))));
        const sB = (kwhTotal * p.PRECIO_KWH) + (dF * p.DISTRIBUCION) + (dF * p.CAPACIDAD) + p.CARGO_FIJO;
        const sBT = sB + (sB * p.PORCENTAJE_BT);
        const net = (sBT + this.calcularAjusteFP(sBT, filaConsumo.fp)) * (1 + this.ivaPorcentaje);
        return { totalNeto: net };
      }

      if (tarifa === 'PDBT') {
        return { totalNeto: ((kwhTotal * this.precios.PDBT.PRECIO_KWH) + this.precios.PDBT.CARGO_FIJO) * (1 + this.ivaPorcentaje) };
      }

      const isDac = tarifa === 'DAC';
      if (isDac) return { totalNeto: ((kwhTotal * this.precios.DAC) + this.precios.CARGO_FIJO_DAC) * (1 + this.ivaPorcentaje) };

      const tp = esVeranoCalculo ? this.precios.VERANO : this.precios.INVIERNO;
      const lims = (TARIFAS_RULES.LIMITES[tarifa] || TARIFAS_RULES.LIMITES['1F'])[esVeranoCalculo ? 'verano' : 'invierno'];
      let r = kwhTotal, c = 0;
      const b = Math.min(r, lims[0]); c += b * tp.BASICO; r -= b;
      if (r > 0) { const i = Math.min(r, lims[1]); c += i * tp.INTERMEDIO; r -= i; }
      if (r > 0 && lims[2]) { const ia = Math.min(r, lims[2]); c += ia * tp.INTERMEDIO_ALTO; r -= ia; }
      if (r > 0) c += r * tp.EXCEDENTE;
      return { totalNeto: (c + this.precios.CARGO_FIJO) * (1 + this.ivaPorcentaje) };
    },

    seleccionarProyecto(id) {
      if (!id) { this.limpiarFormulario(); return; }
      const p = this.listas.proyectosCliente.find(x => x.id_cotizacion == id);
      if (p) this.cargarProyectoExistente(p);
    },

    limpiarFormulario() {
      const cs = this.formData.consumos.map(c => ({ ...c, kwh: null, pago: null, kwhBase: 0, kwhInter: 0, kwhPunta: 0, kwBase: 0, kwInter: 0, kwPunta: 0, demanda: 0, fp: 99 }));
      this.$emit('update:formData', { ...this.formData, nombreProyecto: '', estado_proyecto: '', localidadProyecto: '', latitud: '', longitud: '', direccion: '', tarifaCFE: '' , divisionCFE: '' , numeroServicio: '', idCotizacion: null, consumos: cs });
    },

    cargarProyectoExistente(p) {
      const h = p.meses_consumidos || p.Meses_consumidos || [];
      const cs = h.length > 0 ? h.map(r => ({
        termino: r.nombre || r.periodo_fin,
        kwh: parseFloat(r.Kwh_Consu || 0),
        pago: parseFloat(r.Pago_total || 0),
        kwhBase: parseFloat(r.consumo_base || 0),
        kwhInter: parseFloat(r.consumo_intermedio || 0),
        kwhPunta: parseFloat(r.consumo_punta || 0),
        kwBase: parseFloat(r.demanda_base || 0),
        kwInter: parseFloat(r.demanda_intermedia || 0),
        kwPunta: parseFloat(r.demanda_punta || 0),
        demanda: parseFloat(r.demanda_maxima || 0),
        fp: parseFloat(r.factor_potencia)
      })) : this.formData.consumos;
      if (p.precios_cfe) {
         this.precios = p.precios_cfe;
      }

      if(!["PDBT", "GDMTH", "GDMTO"].includes(p.tipo_tarifa)){
        this.mostrarSmallTextTarifas = true;
      }else{
        this.mostrarSmallTextTarifas = false;
      }
      
      this.$emit('update:formData', { ...this.formData, nombreProyecto: p.nombre_proyecto, estado_proyecto: p.estado_proyecto, localidadProyecto: p.localidad_proyecto, latitud: p.latitud, longitud: p.longitud, direccion: p.direccion, tarifaCFE: p.tipo_tarifa, numeroServicio: p.servicio_cfe, consumos: cs, precios_cfe: this.precios,divisionCFE:p.divisionCFE });
      this.$emit('set-id-cotizacion', p.id_cotizacion);
      this.$nextTick(() => this.recalcularPrecios());
    },

    toggleUnSoloRecibo() {
      if (this.usarUnSoloRecibo) {
        const cs = JSON.parse(JSON.stringify(this.formData.consumos));

        const mod = cs[this.mesBaseIndex];

        for (let i = 0; i < cs.length; i++) {
          if (i === this.mesBaseIndex) continue;

          cs[i].kwh = mod.kwh;

          cs[i].demanda = mod.demanda;
          cs[i].fp = mod.fp;

          const esVeranoDestino = this.esMesVerano(cs[i].termino);

          const res = this.realizarCalculoMatematico(
            mod.kwh,
            esVeranoDestino,
            this.formData.tarifaCFE,
            cs[i]
          );
          cs[i].pago = parseFloat(res.totalNeto.toFixed(2));
        }

        this.$emit('update:formData', { ...this.formData, consumos: cs });
      }
    }
  }
};
</script>

<style scoped>
.form-section-header {
  margin-bottom: 30px;
}

.video-help-container {
  text-align: center;
}

.btn-video-trigger {
  background-color: #29b9f6;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.3s ease;
}

.btn-video-trigger:hover {
  background-color: #1a5f7a;
  transform: scale(1.05);
}

.video-frame {
  margin-top: 15px;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.video-player {
  width: 100%;
  display: block;
}

.video-footer {
  padding: 15px;
  display: flex;
  justify-content: center;
}

.video-footer p {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-link-referencia {
  display: inline-block;
  background-color: #fff;
  color: #29b9f6;
  border: 1px solid #29b9f6;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  text-decoration: none;
  font-weight: 700;
  transition: all 0.2s;
}

.btn-link-referencia:hover {
  background-color: #29b9f6;
  color: #fff;
}

.captura-mode-selector {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  background-color: var(--color-fondo-claro);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--color-borde);
  width: fit-content;
}

.calculator-section {
  margin-top: 30px;
}

.calc-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
}

.calc-card.border-red {
  border: 2px solid #ef4444;
  background-color: #fff5f5;
}

.calc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.calc-header h4 {
  margin: 0;
  color: #2d3748;
  font-size: 16px;
  font-weight: 700;
}

.badge-dac {
  background: #ef4444;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.header-group {
  background-color: #ebf8ff;
  color: #2b6cb0;
  text-align: center;
  border-bottom: 1px solid #cbd5e0;
  font-size: 12px;
  padding: 4px;
}

.sub-header th {
  background-color: #f7fafc;
  font-size: 11px;
  color: #718096;
  padding: 6px 4px;
  text-align: center;
}

.badge-sub {
  background: #22c55e;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.dac-alert-content {
  text-align: center;
  color: #c53030;
}

.icon-warning {
  font-size: 30px;
  margin-bottom: 10px;
}

.captura-mode-selector {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
  background-color: var(--color-fondo-claro);
  padding: 8px 15px;
  border-radius: 8px;
  border: 1px solid var(--color-borde);
  width: 100%;
  box-sizing: border-box;
}

.btn-replicar {
  background-color: #f1f5f9;
  color: #64748b;
  border: 1px solid #cbd5e0;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.btn-replicar:hover {
  background-color: #e2e8f0;
  transform: translateY(-1px);
}

.btn-replicar-activo {
  background-color: #f0fdf4;
  color: #16a34a;
  border-color: #16a34a;
  box-shadow: 0 2px 5px rgba(22, 163, 74, 0.15);
}

.btn-replicar-activo i {
  color: #16a34a;
}

.inline-gdmth-inputs {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 10px;
  padding-left: 15px;
  border-left: 2px solid #29b9f6;
  animation: fadeIn 0.3s ease-in;
}

.mini-input-group {
  display: flex;
  align-items: center;
  gap: 5px;
}

.mini-input-group label {
  font-size: 12px;
  font-weight: 700;
  color: #29b9f6;
  margin: 0;
  white-space: nowrap;
}

.mini-input-group input {
  width: 70px;
  height: 30px;
  padding: 0 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
  background-color: #fff;
}

.mini-input-group input:focus {
  border-color: #29b9f6;
  outline: none;
}

@media (max-width: 768px) {
  .captura-mode-selector {
    flex-direction: column;
    align-items: flex-start;
  }

  .inline-gdmth-inputs {
    margin-left: 0;
    border-left: none;
    padding-left: 0;
    margin-top: 10px;
    flex-wrap: wrap;
  }
}

.ajuste-precios-container {
  margin: 20px 0;
  border-radius: 8px;
  padding: 10px;
  background-color: var(--color-fondo-claro);
  border: 1px solid var(--color-borde);
}

.btn-toggle-precios {
  background: none;
  border: none;
  color: var(--color-secundario);
  font-weight: 600;
  text-align: left;
  padding: 5px;
}

.panel-precios {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e2e8f0;
}


.input-bloqueado {
  background-color: #edf2f7;
  border: 1px solid #cbd5e0;
  color: #4a5568;
  font-weight: bold;
  cursor: default;
}

.consumption-table-wrapper {
  overflow-x: auto;
  margin-bottom: 20px;
  box-shadow: inset -10px 0 10px -10px rgba(0, 0, 0, 0.1);
}

.consumption-table th {
  white-space: nowrap;
  font-size: 13px;
  padding: 10px 5px;
}

.consumption-table input {
  min-width: 60px;
  padding: 8px 5px;
  font-size: 13px;
}

.input-excel:disabled,
input:disabled {
  background-color: #f5f5f5;
  color: #a0aec0;
  cursor: not-allowed;
  font-style: italic;
}

.precios-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.grupo-precios h5 {
  margin: 0 0 10px 0;
  color: #2d3748;
  font-size: 14px;
  text-align: center;
}

.input-precio {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
}

.input-precio label {
  color: black;
}

.input-precio input {
  width: 80px;
  padding: 4px;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  text-align: right;
}

.input-precio.highlight input {
  border-color: #ed8936;
  background-color: #fffaf0;
}

.nota-precios {
  display: block;
  text-align: center;
  color: #a0aec0;
  margin-top: 10px;
  font-style: italic;
}

@media (max-width: 600px) {
  .precios-grid {
    grid-template-columns: 1fr;
  }
}

.form-divider-light {
  border: 0;
  border-top: 1px dashed #e2e8f0;
  margin: 15px 0;
}

.input-precio.highlight input {
  background-color: #f0f9ff;
  border-color: #bee3f8;
}
.bar-row {
  display: grid;
  grid-template-columns: 1.5fr 2fr 0.8fr;
  align-items: center;
  gap: 15px;
  margin-bottom: 12px;
}

.bar-info {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}

.divider-vertical {
  width: 1px;
  height: 20px;
  background: #cbd5e0;
  margin: 0 10px;
}

.checkbox-replicar span {
  color: #2b6cb0;
  font-weight: bold;
}

.bar-info .label {
  font-weight: 600;
  color: #4a5568;
}

.bar-info .kwh {
  color: #718096;
}

.progress-track {
  height: 10px;
  background: #edf2f7;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
}

.progress-fill {
  height: 100%;
  border-radius: 5px;
}

.green {
  background: #48bb78;
}

.yellow {
  background: #ecc94b;
}

.red {
  background: #f56565;
}

.bar-price {
  text-align: right;
  font-weight: 700;
  font-size: 14px;
  color: #2d3748;
}

.text-red {
  color: #e53e3e !important;
}

.fw-bold {
  font-weight: 800;
}

.calc-footer {
  margin-top: 15px;
  text-align: center;
  background: #fffaf0;
  padding: 10px;
  border-radius: 6px;
  color: #c05621;
  font-size: 13px;
  border: 1px dashed #ed8936;
}

@media (max-width: 600px) {
  .bar-row {
    grid-template-columns: 1fr;
    gap: 5px;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }

  .bar-price {
    text-align: left;
  }
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  color: var(--color-texto-secundario);
}

.radio-label input {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.form-section-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-secundario);
  margin-bottom: 8px;
}

.header-icon {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-icon svg {
  color: var(--color-primario);
  width: 20px;
  height: 20px;
}

.form-grid {
  display: grid;
  gap: 25px;
}

.cfe-grid {
  grid-template-columns: 2fr 1fr;
  gap: 30px;
  align-items: start;
}

.cfe-info-grid {
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.cfe-info-grid .span-2 {
  grid-column: span 2;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--color-texto-secundario);
  font-weight: 600;
}

.form-group input,
.form-group select {
  height: 42px;
  border: 1px solid var(--color-borde);
  border-radius: 8px;
  padding: 0 15px;
  font-size: 14px;
  background-color: var(--color-fondo-blanco);
  transition: border-color 0.3s, box-shadow 0.3s;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--color-primario);
  box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.2);
}

.full-width {
  width: 100%;
}

.form-group-column.actions-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 50px;
}

.form-divider {
  border: 0;
  height: 1px;
  background-color: var(--color-borde);
  margin: 40px 0;
}

.consumption-table-wrapper {
  border-radius: 12px;
  overflow: hidden;
  margin-top: 15px;
  overflow-x: auto;
  border: 1px solid var(--color-borde);
}

.consumption-table {
  width: 100%;
  min-width: 550px;
  border-collapse: collapse;
}

.consumption-table th {
  background-color: var(--color-fondo-claro);
  padding: 16px 20px;
  font-weight: 600;
  color: var(--color-secundario);
  text-align: left;
  font-size: 14px;
  border-bottom: 2px solid var(--color-borde);
}

.consumption-table td {
  padding: 8px 10px;
  vertical-align: middle;
}

.consumption-table tbody tr:nth-child(even) {
  background-color: var(--color-fondo-claro);
}

.consumption-table tbody tr:hover {
  background-color: #e2e8f0;
}

.consumption-table input {
  width: 100%;
  padding: 10px 12px;
  height: auto;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
  border: 1px solid var(--color-borde);
  background-color: var(--color-fondo-blanco);
  text-align: right;
}

.consumption-table .cycle-label {
  text-align: left;
  font-weight: 600;
  color: var(--color-texto-principal);
  padding-left: 20px;
}

.text-right {
  text-align: right;
}

.consumption-summary {
  background-color: var(--color-fondo-claro);
  padding: 20px;
  border-radius: 12px;
  margin-top: 25px;
  border: 1px solid var(--color-borde);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.consumption-summary h4 {
  font-size: 16px;
  color: var(--color-secundario);
  margin: 0px;
}

.summary-grid {
  display: flex;
  gap: 30px;
  text-align: center;
}

.summary-item label {
  font-size: 13px;
  color: var(--color-texto-secundario);
  font-weight: 500;
}

.summary-item span {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: var(--color-primario);
}

@media (max-width: 768px) {

  .cfe-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .cfe-info-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .cfe-info-grid .span-2 {
    grid-column: span 1;
  }

  .form-group-column.actions-column {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
    margin-top: 0;
  }

  .form-group-column.actions-column button {
    flex-basis: 100%;
  }

  .consumption-table {
    min-width: 500px;
  }

  .summary-grid {
    flex-direction: column;
    gap: 15px;
  }

  .consumption-summary h4 {
    font-size: 15px;
    text-align: center;
    margin-bottom: 15px;
  }

  .consumption-summary {
    display: flex;
    flex-direction: column;
  }
}

@media (min-width: 769px) {
  .cfe-details {
    grid-column: span 1;
  }
}

.select-mes-base {
  border: 1px solid #48bb78;
  color: #2f855a;
  font-weight: bold;
  border-radius: 4px;
  padding: 2px 5px;
}

.label-mes-base {
  font-size: 12px;
  color: #48bb78;
  font-weight: 700;
}

.fila-seleccionada td {
  background-color: #f0fff4 !important;
  border-top: 2px solid #48bb78;
  border-bottom: 2px solid #48bb78;
}

.fila-automatica input {
  color: #718096;

  font-style: italic;
}

.input-excel-total {
  background-color: #ffffff;
  border: 2px solid #22c55e;
  color: #15803d;
  font-weight: 800;
  text-align: right;
  border-radius: 4px;
}
</style>